import { LoginPage } from './login/Login';

export const auth = {
  login: LoginPage,
};
